var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgPaperBulb(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M23.038 6.738v18.396h-14.3V11.372l.038-.191.073-.177.109-.162 3.884-3.884.162-.109.177-.073.19-.038h9.667zm-1 .999h-8.563l-3.738 3.738v12.658h12.301V7.737zm-3.905 11.834v1.215c0 .582-.41 1.078-.983 1.192l-.125.018-.092.004h-1.866c-.58 0-1.068-.419-1.179-.996l-.018-.126-.003-.092V19.57h4.266zm-1 1h-2.267l.002.236a.213.213 0 00.14.183l.059.01h1.885a.206.206 0 00.172-.15l.01-.064-.001-.215zM16 10c2.211 0 4 1.826 4 4.071a4.096 4.096 0 01-1.31 3.01l-.09.078v.722c0 .495-.296.93-.746 1.12l-.126.046-.122.03-.114.014-.092.004h-2.8c-.58 0-1.067-.419-1.178-.996l-.018-.126-.004-.092v-.718l-.16-.147a4.085 4.085 0 01-1.169-2.183l-.036-.23-.024-.233-.008-.154-.003-.145C12 11.826 13.789 10 16 10zm0 1c-1.595 0-2.903 1.277-2.995 2.883l-.005.18.002.117.007.125a3.08 3.08 0 001.019 2.08l.157.13.215.149v1.194l.001.045a.213.213 0 00.141.183l.058.01h2.776l.018.001.042-.005a.208.208 0 00.156-.15l.008-.061v-1.198l.29-.228A3.09 3.09 0 0019 14.07c0-1.697-1.346-3.07-3-3.07z"
  }));
}

export default SvgPaperBulb;